import { type ApiResponse, http } from "@/shared/api";


export type { AICreateTaskPayload } from '@/shared/lib/task/task-payload'

/**
 * 通用任务提交结果返回
 */
export interface AICreateTaskResult {
    /** 任务创建返回 id，这个不是 task_id */
    run_id: string
}

export function requestAISubmitTask(payload: { project_id: string; node_id: string; is_list?: boolean; point: number; image_point: number; key?: string; model?: string }): Promise<ApiResponse<AICreateTaskResult>> {
    return http.post<AICreateTaskResult>('/zs/AiCanvasTask/submitTask', payload);
}

export function requestAISubmitTaskGroup(payload: { project_id: string; group_id: string, is_continue?: boolean, run_id?: string, point: number, image_point: number }): Promise<ApiResponse<AICreateTaskResult>> {
    return http.post<AICreateTaskResult>('/zs/AiCanvasTask/submitTaskGroup', payload);
}

// ── 任务列表面板所需 API ─────────────────────────────────

export interface TaskListParams {
    page: number;
    project_id: string;
    ids?: string[];
    task_ids?: string[];
    node_type?: string;
}

export interface TaskListData {
    list: import('../model/task-store').ServerTaskItem[];
    total?: number;
}

export function requestTaskList(params: TaskListParams): Promise<ApiResponse<TaskListData>> {
    return http.post<TaskListData>('/zs/AiCanvasTask/taskList', params as unknown as Record<string, unknown>);
}

// 删除任务（支持单条和批量删除）
export function requestTaskDelete(taskId: string | string[]): Promise<ApiResponse<unknown>> {
    return http.post<unknown>('/zs/AiCanvasTask/taskDel', { task_id: taskId });
}

// 取消任务
export function requestTaskCancel(runId: string): Promise<ApiResponse<unknown>> {
    return http.post<unknown>('/zs/AiCanvasTask/taskCancel', { run_id: runId });
}

export function requestTaskInfo(taskId: string): Promise<ApiResponse<any>> {
    return http.post<any>('/zs/AiCanvasTask/taskInfo', { task_id: taskId });
}

export function requestTaskDetail(taskId: string): Promise<ApiResponse<import('../model/task-store').ServerTaskItem>> {
    return http.post<import('../model/task-store').ServerTaskItem>('/zs/AiCanvasTask/taskDetail', { task_id: taskId });
}
